import { create } from 'zustand';

/**
 * Control del movimiento automático de la cámara.
 *
 * El dashboard puede mover/encuadrar la cámara por sí solo: auto-encuadre al
 * llegar una alarma, vuelta a la vista por defecto, o comandos de un agente
 * LLM. El operador puede desactivarlo (atajo `c`) para quedarse con el control
 * manual; con `autoMove` en false, el `CameraController` ignora los `fly_to`
 * entrantes (las alarmas siguen mostrándose, solo no mueven la cámara).
 */
// Tras un fly_to manual (tecla I), ventana durante la que se ignoran los
// fly_to automáticos — evita que un auto-encuadre de alarma o el regreso a
// la vista por defecto le pise la navegación al operador segundos después.
const MANUAL_OVERRIDE_MS = 8000;

interface CameraControlState {
  autoMove: boolean;
  toggleAutoMove: () => void;
  setAutoMove: (v: boolean) => void;
  manualUntil: number;
  markManual: () => void;
}

export const useCameraControl = create<CameraControlState>((set) => ({
  autoMove: true,
  toggleAutoMove: () => set((s) => ({ autoMove: !s.autoMove })),
  setAutoMove: (v) => set({ autoMove: v }),
  manualUntil: 0,
  markManual: () => set({ manualUntil: Date.now() + MANUAL_OVERRIDE_MS }),
}));
